export const arrayToCSV = (array: any[]): string => {
  if (array.length === 0) return '';

  const keys: string[] = Object.keys(array[0]);
  const data = [keys, ...array.map(row => keys.map(k => row[k]))];
  return data.map(row => row.join(',')).join('\n');
};
